import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  "aria-label": "breadcrumb",
  class: "mt-5 pt-5 ps-3"
}
const _hoisted_2 = { class: "breadcrumb mb-3" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_6 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_7 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_9 = { class: "d-flex gap-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = { class: "mb-1" }
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_20 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "grow" }
const _hoisted_23 = {
  key: 2,
  class: "row"
}
const _hoisted_24 = { class: "card h-100 workspace-card border-0 shadow-sm" }
const _hoisted_25 = { class: "card-img-top workspace-logo-container" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = {
  key: 1,
  class: "workspace-logo-placeholder d-flex align-items-center justify-content-center"
}
const _hoisted_28 = { class: "card-body d-flex flex-column" }
const _hoisted_29 = ["title"]
const _hoisted_30 = {
  key: 0,
  class: "badge bg-primary ms-2",
  title: "AI Generated Workspace"
}
const _hoisted_31 = { class: "mb-2" }
const _hoisted_32 = { class: "d-flex align-items-center mt-1" }
const _hoisted_33 = ["src", "alt"]
const _hoisted_34 = {
  key: 1,
  class: "fa fa-user-circle me-2 text-muted"
}
const _hoisted_35 = { class: "small fw-medium" }
const _hoisted_36 = { class: "mb-2" }
const _hoisted_37 = { class: "bg-light px-1 rounded" }
const _hoisted_38 = { class: "card-text text-muted small grow" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 1,
  class: "fst-italic"
}
const _hoisted_41 = { class: "mt-auto" }
const _hoisted_42 = { class: "row g-2 text-center" }
const _hoisted_43 = { class: "col-4" }
const _hoisted_44 = { class: "d-flex flex-column" }
const _hoisted_45 = { class: "h6 mb-0 text-primary" }
const _hoisted_46 = { class: "col-4" }
const _hoisted_47 = { class: "d-flex flex-column" }
const _hoisted_48 = { class: "h6 mb-0 text-success" }
const _hoisted_49 = { class: "col-4" }
const _hoisted_50 = { class: "d-flex flex-column" }
const _hoisted_51 = { class: "h6 mb-0 text-info" }
const _hoisted_52 = { class: "card-footer bg-transparent border-top-0 pt-0" }
const _hoisted_53 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_54 = { class: "text-muted" }
const _hoisted_55 = ["disabled", "onClick"]
const _hoisted_56 = {
  key: 3,
  class: "text-center py-5"
}
const _hoisted_57 = { class: "mt-3" }
const _hoisted_58 = {
  key: 0,
  class: "card-footer bg-light border-bottom"
}
const _hoisted_59 = { class: "row text-center" }
const _hoisted_60 = { class: "col-md-2 col-6 mb-2 mb-md-0" }
const _hoisted_61 = { class: "d-flex flex-column" }
const _hoisted_62 = { class: "h5 mb-0 text-primary" }
const _hoisted_63 = { class: "col-md-2 col-6 mb-2 mb-md-0" }
const _hoisted_64 = { class: "d-flex flex-column" }
const _hoisted_65 = { class: "h5 mb-0 text-success" }
const _hoisted_66 = { class: "col-md-2 col-6 mb-2 mb-md-0" }
const _hoisted_67 = { class: "d-flex flex-column" }
const _hoisted_68 = { class: "h5 mb-0 text-warning" }
const _hoisted_69 = { class: "col-md-2 col-6 mb-2 mb-md-0" }
const _hoisted_70 = { class: "d-flex flex-column" }
const _hoisted_71 = { class: "h5 mb-0 text-info" }
const _hoisted_72 = { class: "col-md-2 col-6 mb-2 mb-md-0" }
const _hoisted_73 = { class: "d-flex flex-column" }
const _hoisted_74 = { class: "h5 mb-0 text-secondary" }
const _hoisted_75 = { class: "col-md-2 col-6" }
const _hoisted_76 = { class: "d-flex flex-column" }
const _hoisted_77 = { class: "h5 mb-0 text-dark" }
const _hoisted_78 = {
  key: 1,
  class: "card-footer d-flex justify-content-end align-items-center gap-3"
}
const _hoisted_79 = { class: "d-flex align-items-center gap-2" }
const _hoisted_80 = ["value"]
const _hoisted_81 = { class: "pagination-mini" }
const _hoisted_82 = ["disabled"]
const _hoisted_83 = ["disabled", "onClick"]
const _hoisted_84 = ["disabled"]
const _hoisted_85 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0, 0, 0, 0.5)"}
}
const _hoisted_86 = { class: "modal-dialog modal-lg" }
const _hoisted_87 = { class: "modal-content" }
const _hoisted_88 = { class: "modal-header" }
const _hoisted_89 = { class: "modal-title" }
const _hoisted_90 = { class: "modal-body" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-md-4" }
const _hoisted_93 = ["src", "alt"]
const _hoisted_94 = {
  key: 1,
  class: "bg-light rounded d-flex align-items-center justify-content-center",
  style: {"height":"200px"}
}
const _hoisted_95 = { class: "col-md-8" }
const _hoisted_96 = { class: "table table-borderless table-sm" }
const _hoisted_97 = { class: "d-flex align-items-center" }
const _hoisted_98 = ["src", "alt"]
const _hoisted_99 = {
  key: 1,
  class: "fa fa-user-circle me-2 text-muted"
}
const _hoisted_100 = { class: "d-flex flex-column" }
const _hoisted_101 = { class: "text-muted" }
const _hoisted_102 = { class: "table table-borderless table-sm" }
const _hoisted_103 = { class: "badge bg-primary" }
const _hoisted_104 = { class: "badge bg-success" }
const _hoisted_105 = { class: "badge bg-info" }

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import apiService from "@/services/apiService";
import { usePermissions } from "@/composables/usePermissions";
interface User {
  _id: string;
  username: string;
  logo: string | null;
  email: string;
}

interface Workspace {
  _id: string;
  logo: string | null;
  title: string;
  idea?: string;
  no_of_lanes: number;
  no_of_modules: number;
  no_of_people: number;
  is_ai_generated: boolean;
  created_at: string;
  created_by: User;
}

// Reactive data

export default /*@__PURE__*/_defineComponent({
  __name: 'AllWorkspaces',
  setup(__props) {

const { canView, canCreate, canDelete, canUpdate } = usePermissions(); 

const router = useRouter();

// Types
const workspaces = ref<Workspace[]>([]);
const filteredWorkspaces = ref<Workspace[]>([]);
const selectedWorkspace = ref<Workspace | null>(null);
const isLoading = ref(false);
const error = ref<string | null>(null);
const showModal = ref(false);

// Tab state
const activeTab = ref<"default" | "byusers">("default");

// Pagination state
const tablePagination = ref({
  current_page: 1,
  per_page: 12,
  total: 0,
  total_pages: 0,
  has_next: false,
  has_prev: false,
});

// Computed properties
const visiblePages = computed(() => {
  const total = tablePagination.value.total_pages;
  const current = tablePagination.value.current_page;

  if (!total || total <= 4) {
    return Array.from({ length: Math.max(1, total) }, (_, i) => i + 1);
  }

  const pages: (number | string)[] = [];
  pages.push(1);

  if (current > 4) pages.push("...");

  const windowStart = Math.max(2, current - 1);
  const windowEnd = Math.min(total - 1, current + 1);
  for (let i = windowStart; i <= windowEnd; i++) pages.push(i);

  if (current < total - 3) pages.push("...");

  pages.push(total);
  return pages;
});

// Computed properties
const totalLanes = computed(() =>
  workspaces.value.reduce((sum, ws) => sum + ws.no_of_lanes, 0)
);

const totalModules = computed(() =>
  workspaces.value.reduce((sum, ws) => sum + ws.no_of_modules, 0)
);

const totalPeople = computed(() =>
  workspaces.value.reduce((sum, ws) => sum + ws.no_of_people, 0)
);

const uniqueCreators = computed(() => {
  const creatorIds = new Set(
    workspaces.value.map((ws) => ws.created_by?._id).filter(Boolean)
  );
  return creatorIds.size;
});

const aiGeneratedCount = computed(
  () => workspaces.value.filter((ws) => ws.is_ai_generated).length
);

// Methods
const setActiveTab = (tab: "default" | "byusers") => {
  activeTab.value = tab;
  tablePagination.value.current_page = 1; // Reset to first page
  loadWorkspaces();
};

const changeRows = async () => {
  tablePagination.value.current_page = 1;
  await loadWorkspaces();
};

const handlePageChange = async (page: number) => {
  if (page < 1 || page === tablePagination.value.current_page) return;
  if (
    tablePagination.value.total_pages &&
    page > tablePagination.value.total_pages
  )
    return;

  tablePagination.value.current_page = page;
  await loadWorkspaces();
};

const loadWorkspaces = async () => {
  isLoading.value = true;
  error.value = null;

  try {
    const page = tablePagination.value.current_page;
    const limit = tablePagination.value.per_page;
    const isDefault = activeTab.value === "default";

    console.log(`Loading ${activeTab.value} workspaces (page: ${page}, limit: ${limit})...`);
    
    // Passing pagination and tab parameters
    const response = await apiService.get("/common/cms/all-workspaces", {
      default: isDefault,
      page,
      limit,
    });

    console.log("Workspaces API Response:", response);

    // Standard format handle: { status, message, data, pagination }
    if (response && response.data && Array.isArray(response.data)) {
      workspaces.value = response.data;
      
      // Update pagination metadata
      if (response.pagination) {
        tablePagination.value.total = response.pagination.total || 0;
        tablePagination.value.total_pages = response.pagination.total_pages || 1;
        tablePagination.value.has_next = page < tablePagination.value.total_pages;
        tablePagination.value.has_prev = page > 1;
      }
      
      console.log(`Loaded ${workspaces.value.length} workspaces`);
    } else if (Array.isArray(response)) {
      // Fallback for old format if necessary
      workspaces.value = response;
      tablePagination.value.total = response.length;
      tablePagination.value.total_pages = 1;
      tablePagination.value.has_next = false;
      tablePagination.value.has_prev = false;
    } else {
      console.error("Invalid response structure:", response);
      throw new Error(`Invalid response format`);
    }
  } catch (err: any) {
    console.error("Error loading workspaces:", err);
    error.value = err?.response?.data?.message || err?.message || "Failed to load workspaces";
    workspaces.value = [];
  } finally {
    isLoading.value = false;
  }
};

const viewWorkspaceDetails = (workspace: Workspace) => {
  selectedWorkspace.value = workspace;
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  selectedWorkspace.value = null;
};

const formatTimeAgo = (createdAt: string): string => {
  const date = new Date(createdAt);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) {
    return "today";
  } else if (diffInDays === 1) {
    return "yesterday";
  } else if (diffInDays < 7) {
    return `${diffInDays} days ago`;
  } else if (diffInDays < 30) {
    const weeks = Math.floor(diffInDays / 7);
    return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
  } else if (diffInDays < 365) {
    const months = Math.floor(diffInDays / 30);
    return `${months} month${months > 1 ? "s" : ""} ago`;
  } else {
    const years = Math.floor(diffInDays / 365);
    return `${years} year${years > 1 ? "s" : ""} ago`;
  }
};

// Lifecycle
onMounted(() => {
  loadWorkspaces();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("li", {
          class: "breadcrumb-item active",
          "aria-current": "page"
        }, " All Workspaces ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: activeTab.value === 'default' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('default'))),
              type: "button"
            }, " Default ", 2)
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: activeTab.value === 'byusers' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('byusers'))),
              type: "button"
            }, " By Users ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (activeTab.value === 'default')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary",
                disabled: !_unref(canCreate)('main'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/createproject')))
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "fa fa-plus me-2" }, null, -1),
                _createTextVNode(" Create Workspace ", -1)
              ]))], 8, _hoisted_10))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            onClick: loadWorkspaces,
            disabled: isLoading.value
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
            _createTextVNode(" Refresh ", -1)
          ]))], 8, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createElementVNode("h5", _hoisted_16, _toDisplayString(activeTab.value === 'default' ? 'Default Workspaces' : 'User Workspaces'), 1),
                _createElementVNode("small", _hoisted_17, _toDisplayString(activeTab.value === 'default' ? 'List of official default workspaces' : 'Workspaces created by registered users'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1),
                    _createElementVNode("p", { class: "mt-2" }, "Loading all workspaces...", -1)
                  ]))]))
                : (error.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                        _createElementVNode("div", _hoisted_22, [
                          _cache[12] || (_cache[12] = _createElementVNode("strong", null, "Error:", -1)),
                          _createTextVNode(" " + _toDisplayString(error.value), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-danger",
                          onClick: loadWorkspaces
                        }, [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("i", { class: "fa fa-refresh" }, null, -1),
                          _createTextVNode(" Retry ", -1)
                        ]))])
                      ])
                    ]))
                  : (workspaces.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (workspace) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: workspace._id,
                            class: "col-lg-4 col-md-6 col-sm-12 mb-4"
                          }, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                (workspace.logo)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: workspace.logo,
                                      alt: workspace.title,
                                      class: "workspace-logo"
                                    }, null, 8, _hoisted_26))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[15] || (_cache[15] = [
                                      _createElementVNode("i", { class: "fa fa-briefcase fa-2x text-muted" }, null, -1)
                                    ]))]))
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("h6", {
                                  class: "card-title text-truncate",
                                  title: workspace.title
                                }, [
                                  _createTextVNode(_toDisplayString(workspace.title) + " ", 1),
                                  (workspace.is_ai_generated)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, [...(_cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "fa fa-robot me-1" }, null, -1),
                                        _createTextVNode("AI ", -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_29),
                                _createElementVNode("div", _hoisted_31, [
                                  _cache[18] || (_cache[18] = _createElementVNode("small", { class: "text-muted" }, "Created by:", -1)),
                                  _createElementVNode("div", _hoisted_32, [
                                    (workspace.created_by?.logo)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: workspace.created_by.logo,
                                          alt: workspace.created_by.username,
                                          class: "rounded-circle me-2",
                                          style: {"width":"20px","height":"20px","object-fit":"cover"}
                                        }, null, 8, _hoisted_33))
                                      : (_openBlock(), _createElementBlock("i", _hoisted_34)),
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(workspace.created_by?.username || "Unknown User"), 1),
                                    (workspace.created_by?._id)
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 2,
                                          to: `/user-workspaces/${workspace.created_by._id}`,
                                          class: "btn btn-link btn-sm p-0 ms-2",
                                          title: "View user's workspaces"
                                        }, {
                                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                            _createElementVNode("i", { class: "fa fa-external-link-alt text-muted" }, null, -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["to"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _cache[19] || (_cache[19] = _createElementVNode("small", { class: "text-muted" }, "ID:", -1)),
                                  _createElementVNode("code", _hoisted_37, _toDisplayString(workspace._id.slice(-8)), 1)
                                ]),
                                _createElementVNode("p", _hoisted_38, [
                                  (workspace.idea && workspace.idea.trim())
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(workspace.idea), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_40, "No description provided"))
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("span", _hoisted_45, _toDisplayString(workspace.no_of_lanes), 1),
                                        _cache[20] || (_cache[20] = _createElementVNode("small", { class: "text-muted" }, "Lanes", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("span", _hoisted_48, _toDisplayString(workspace.no_of_modules), 1),
                                        _cache[21] || (_cache[21] = _createElementVNode("small", { class: "text-muted" }, "Modules", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("span", _hoisted_51, _toDisplayString(workspace.no_of_people), 1),
                                        _cache[22] || (_cache[22] = _createElementVNode("small", { class: "text-muted" }, "People", -1))
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("small", null, [
                                      _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fa fa-calendar me-1" }, null, -1)),
                                      _createTextVNode(" Created " + _toDisplayString(formatTimeAgo(workspace.created_at)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                      class: "btn btn-outline-primary btn-sm",
                                      disabled: !_unref(canView)('main'),
                                      onClick: ($event: any) => (viewWorkspaceDetails(workspace))
                                    }, [...(_cache[24] || (_cache[24] = [
                                      _createElementVNode("i", { class: "fa fa-eye me-1" }, null, -1),
                                      _createTextVNode(" View ", -1)
                                    ]))], 8, _hoisted_55)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mb-3" }, [
                          _createElementVNode("i", { class: "fa fa-briefcase fa-3x text-muted" })
                        ], -1)),
                        _cache[27] || (_cache[27] = _createElementVNode("h5", { class: "text-muted" }, "No Workspaces Found", -1)),
                        _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-muted" }, "No workspaces have been created yet.", -1)),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (loadWorkspaces()))
                          }, [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                            _createTextVNode(" Refresh ", -1)
                          ]))])
                        ])
                      ]))
            ]),
            (workspaces.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("span", _hoisted_62, _toDisplayString(tablePagination.value.total), 1),
                        _cache[29] || (_cache[29] = _createElementVNode("small", { class: "text-muted" }, "Total Workspaces", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("span", _hoisted_65, _toDisplayString(totalLanes.value), 1),
                        _cache[30] || (_cache[30] = _createElementVNode("small", { class: "text-muted" }, "Total Lanes", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("span", _hoisted_68, _toDisplayString(totalModules.value), 1),
                        _cache[31] || (_cache[31] = _createElementVNode("small", { class: "text-muted" }, "Total Modules", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("span", _hoisted_71, _toDisplayString(totalPeople.value), 1),
                        _cache[32] || (_cache[32] = _createElementVNode("small", { class: "text-muted" }, "Total People", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("span", _hoisted_74, _toDisplayString(uniqueCreators.value), 1),
                        _cache[33] || (_cache[33] = _createElementVNode("small", { class: "text-muted" }, "Unique Creators", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("span", _hoisted_77, _toDisplayString(aiGeneratedCount.value), 1),
                        _cache[34] || (_cache[34] = _createElementVNode("small", { class: "text-muted" }, "AI Generated", -1))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (workspaces.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-muted small" }, "Rows per page:", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm rows-select",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tablePagination.value.per_page) = $event)),
                      onChange: changeRows
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([6, 12, 24, 48, 96], (n) => {
                        return _createElementVNode("option", {
                          key: n,
                          value: n
                        }, _toDisplayString(n), 9, _hoisted_80)
                      }), 64))
                    ], 544), [
                      [_vModelSelect, tablePagination.value.per_page]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("button", {
                      class: "page-btn prev_btn",
                      disabled: !tablePagination.value.has_prev || isLoading.value,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (handlePageChange(tablePagination.value.current_page - 1)))
                    }, " « ", 8, _hoisted_82),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: index,
                        class: _normalizeClass(["page-btn", {
                    'page-active': p === tablePagination.value.current_page,
                    'disabled-dots': p === '...',
                  }]),
                        disabled: p === '...' || isLoading.value,
                        onClick: ($event: any) => (
                    p !== '...' &&
                      typeof p === 'number' &&
                      handlePageChange(p)
                  )
                      }, _toDisplayString(p), 11, _hoisted_83))
                    }), 128)),
                    _createElementVNode("button", {
                      class: "page-btn next_btn",
                      disabled: !tablePagination.value.has_next || isLoading.value,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (handlePageChange(tablePagination.value.current_page + 1)))
                    }, " » ", 8, _hoisted_84)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (showModal.value && selectedWorkspace.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("h5", _hoisted_89, " Workspace Details: " + _toDisplayString(selectedWorkspace.value.title), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closeModal,
                  "aria-label": "Close"
                })
              ]),
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    (selectedWorkspace.value.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: selectedWorkspace.value.logo,
                          alt: selectedWorkspace.value.title,
                          class: "img-fluid rounded"
                        }, null, 8, _hoisted_93))
                      : (_openBlock(), _createElementBlock("div", _hoisted_94, [...(_cache[36] || (_cache[36] = [
                          _createElementVNode("i", { class: "fa fa-briefcase fa-3x text-muted" }, null, -1)
                        ]))]))
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    _cache[46] || (_cache[46] = _createElementVNode("h6", null, "Basic Information", -1)),
                    _createElementVNode("table", _hoisted_96, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[37] || (_cache[37] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "ID:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("code", null, _toDisplayString(selectedWorkspace.value._id), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[38] || (_cache[38] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Title:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(selectedWorkspace.value.title), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[40] || (_cache[40] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Created By:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_97, [
                              (selectedWorkspace.value.created_by?.logo)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: selectedWorkspace.value.created_by.logo,
                                    alt: selectedWorkspace.value.created_by.username,
                                    class: "rounded-circle me-2",
                                    style: {"width":"24px","height":"24px","object-fit":"cover"}
                                  }, null, 8, _hoisted_98))
                                : (_openBlock(), _createElementBlock("i", _hoisted_99)),
                              _createElementVNode("div", _hoisted_100, [
                                _createElementVNode("span", null, _toDisplayString(selectedWorkspace.value.created_by?.username ||
                              "Unknown User"), 1),
                                _createElementVNode("small", _hoisted_101, _toDisplayString(selectedWorkspace.value.created_by?.email || ""), 1)
                              ]),
                              (selectedWorkspace.value.created_by?._id)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 2,
                                    to: `/user-workspaces/${selectedWorkspace.value.created_by._id}`,
                                    class: "btn btn-link btn-sm p-0 ms-2",
                                    title: "View user's workspaces",
                                    onClick: closeModal
                                  }, {
                                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                      _createElementVNode("i", { class: "fa fa-external-link-alt" }, null, -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[41] || (_cache[41] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Idea:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(selectedWorkspace.value.idea || "No description provided"), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[42] || (_cache[42] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "AI Generated:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                            selectedWorkspace.value.is_ai_generated
                              ? 'badge bg-success'
                              : 'badge bg-secondary'
                          )
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass([
                              selectedWorkspace.value.is_ai_generated
                                ? 'fa fa-robot'
                                : 'fa fa-user'
                            , "me-1"])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(selectedWorkspace.value.is_ai_generated
                              ? "Yes (AI Generated)"
                              : "No (Manual)"), 1)
                            ], 2)
                          ])
                        ])
                      ])
                    ]),
                    _cache[47] || (_cache[47] = _createElementVNode("h6", null, "Statistics", -1)),
                    _createElementVNode("table", _hoisted_102, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[43] || (_cache[43] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Lanes:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_103, _toDisplayString(selectedWorkspace.value.no_of_lanes), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[44] || (_cache[44] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Modules:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_104, _toDisplayString(selectedWorkspace.value.no_of_modules), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[45] || (_cache[45] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "People:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_105, _toDisplayString(selectedWorkspace.value.no_of_people), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closeModal
                }, " Close ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})